import { Routes } from '@angular/router';
import { AuthGuard } from './guard/auth.guard';
import { ViewResolver } from './resolver/view.resolver';

export const routes: Routes = [
    {
        path: 'member/**',
        loadComponent: () =>
            import('./component/view/view.component').then(m => m.ViewComponent),
        resolve: { view: ViewResolver },
        canActivate: [AuthGuard]
    },
    {
        path: 'login',
        loadComponent: () =>
            import('./component/view/view.component').then(m => m.ViewComponent),
        resolve: { view: ViewResolver }
    },
    {
        path: '',
        redirectTo: 'index',
        pathMatch: 'full',
    },
    {
        path: '**',
        loadComponent: () =>
            import('./component/view/view.component').then(m => m.ViewComponent),
        resolve: { view: ViewResolver }
    },
];
